'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
require('./Card.css');
var _propTypes = require('prop-types');
var _propTypes2 = _interopRequireDefault(_propTypes);
var _classnames = require('classnames');
var _classnames2 = _interopRequireDefault(_classnames);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

/**
 * A card body to be used within a card.
 */
var CardBody = function CardBody(_ref) {
  var spacedOutX = _ref.spacedOutX,
    children = _ref.children;
  var baseClass = (0, _classnames2.default)('c-card__body', {
    'c-card__body--spaced-out-x': spacedOutX
  });
  return _react2.default.createElement('div', {
    className: baseClass
  }, children);
};
CardBody.propTypes = process.env.NODE_ENV !== "production" ? {
  /** Renders children in horizontal spaced out fashion*/
  spacedOutX: _propTypes2.default.bool,
  /** Children of the card body */
  children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node])
} : {};
exports.default = CardBody;